import { environment } from '../../../environments/environment';
import { Component, HostListener, OnInit } from '@angular/core';
import { LocaleService, TranslationService } from 'angular-l10n';
import { ApiService } from '../../services/api.service';
import { Onboarding, Status, PuntoDiContatto, LeadSource } from '../../models/onboarding';
import { Observable } from 'rxjs/Observable';
import { AlgGtmService } from '../../services/alg-gtm.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'alg-onboarding',
  templateUrl: './alg-onboarding.component.html',
  styleUrls: ['./alg-onboarding.component.scss'],
})
export class AlgOnboardingComponent implements OnInit {
  title = 'Luce&Gas Coop Onboarding';

  public isMobile = false;
  public isDesktop = false;
  public actualWidth: any;
  public onboarding: Onboarding = {} as Onboarding;
  public isLoading: Observable<boolean>;
  public onbError: Observable<any>;

  public containerOnboardingStatusChange: string;
  public currentStatusFromStep: string | null = null;

  private getParams(search: string): any {
    const params = {};
    search
      .slice(1)
      .split('&')
      .forEach((e) => {
        const [k, v] = e.split('=');
        params[k] = v;
      });
    return params;
  }

  ngOnInit(): void {
    const params = this.getParams(location.search);
    let productSlug = params.prd;
    const idOnb = params.oid;
    let promoCode = null;
    let comparatore = null;
    let green = null;
    this.actualWidth = window.innerWidth;

    // IUBENDA BANNER Function
    this.loadExternalScript();

    if (this.actualWidth <= 767) {
      this.isMobile = true;
      this.isDesktop = false;
    } else {
      this.isMobile = false;
      this.isDesktop = true;
    }

    this.route.params.subscribe((url_params) => {
      if (url_params.prodotto) {
        productSlug = url_params.prodotto;
      }
      if (url_params.primary) {
        switch (url_params.primary) {
          case 'green':
            green = true;
            break;
          default:
            comparatore = url_params.primary;
            break;
        }
      }
      if (url_params.secondary) {
        promoCode = url_params.secondary;
      }

      if (!(productSlug || idOnb)) {
        // no id and no product
        window.location.href = environment.websiteUrl;
      }

      if (productSlug) {
        this.api
          .updateProductBySlug(productSlug)
          .toPromise()
          .then((products) => {
            if (!products || products.length === 0) {
              window.location.href = environment.websiteUrl;
              return;
            }
            const product = products[0];
            const initialOnboarding: Onboarding = {} as Onboarding;
            initialOnboarding.product = product._id;
            initialOnboarding.webStatus = Status.userInfo;
            if (promoCode) {
              initialOnboarding.promoCode = promoCode.toUpperCase();
              initialOnboarding.isPromoSelected = false;
            }
            if (comparatore) {
              let selectedComparatore;
              Object.values(PuntoDiContatto).forEach((el: any, i) => {
                el = el.toLowerCase();
                if (el === comparatore.toLowerCase()) {
                  selectedComparatore = Object.values(PuntoDiContatto)[i];
                }
              });
              if (!selectedComparatore) {
                window.location.href = environment.websiteUrl;
              }
              initialOnboarding.puntoDiContatto = selectedComparatore;
            }
            if (product.greenEnergy || green) {
              this.api.currentLightGreen.next(true);
            }
            this.gtm.stepEvent(initialOnboarding.webStatus, product.family.name, product.type);

            this.api.saveOnboarding(initialOnboarding, false);
          })
          .catch((e) => console.log(e));
      } else if (idOnb) {
        this.api
          .updateOnboarding(idOnb)
          .toPromise()
          .then((onboarding) => {
            if (!onboarding || onboarding === []) {
              window.location.href = environment.websiteUrl;
              return;
            }
            if (onboarding.leadSource === LeadSource.blacklist) {
              this.api.onbError.next({
                err: true,
                mess: this.translation.translate('BLACKLIST_ERROR_MESSAGE'),
              });
              return;
            }
            if (idOnb && onboarding.product) {
              const productId = typeof onboarding.product === 'string' ? onboarding.product : onboarding.product._id;
              this.api.updateProductById(productId);
            }
            this.onboarding = onboarding;
            this.api.currentLightGreen.next(onboarding.lightGreen || false);
            this.api.setCurrentStep(onboarding.webStatus);
          });
      }

      this.api.currentOnboarding.subscribe((onb) => {
        this.onboarding = onb;
        if (url_params.secondary) {
          this.onboarding.isDefaultPromo = true;
        }
      });

      this.api.currentProduct.subscribe((p) => {
        if (p.family) {
          const filters: any = {
            productFamilies: p.family._id,
          };
          this.api.getPromotions(filters, p.duration);
        }
      });

      this.api.promotions.subscribe((promotions) => {
        if (this.onboarding.promoCode) {
          const currentPromo = promotions.find((p) => p.code === this.onboarding.promoCode);
          if (!currentPromo) {
            this.api.saveOnboarding({ ...this.onboarding, promoCode: '', isPromoSelected: false }, false);
          }
        }
      });

      this.api.getPromotions();
      this.api.getCooperatives();
      this.api.getOptions();
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth <= 767) {
      this.isMobile = true;
      this.isDesktop = false;
    } else {
      this.isMobile = false;
      this.isDesktop = true;
    }
  }

  /* @HostListener('window:beforeunload', ['$event']) */
  unloadHandler() {
    return false;
  }

  constructor(
    public locale: LocaleService,
    public translation: TranslationService,
    private api: ApiService,
    private gtm: AlgGtmService,
    private route: ActivatedRoute
  ) {
    this.isLoading = this.api.isLoading.asObservable();
    this.onbError = this.api.onbError.asObservable();
  }

  public log(event) {
    console.log(event);
  }

  public onboardingChangeStatus(event) {
    this.containerOnboardingStatusChange = event;
  }

  public onboardingChangeStatusFromStepsComponent(event) {
    this.currentStatusFromStep = event;
  }

  public onboardingSetCurrentStatus(event) {
    console.log('onboardingSetCurrentStatus', event);
    this.containerOnboardingStatusChange = event;
  }

  // Script for Iubenda only ONBOARDING
  public loadExternalScript() {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = '/src/assets/js/iubenda.js';
    script.async = true;
    script.defer = true;
    body.appendChild(script);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/alg-onboarding/alg-onboarding.component.ts